import React, {useState} from 'react';
import {Button, Card, FormLayout, InlineGrid, Link, Text, TextField} from "@shopify/polaris";
import MGSelect from "../../helper/MGSelect";
import macBookImg from "../../assets/img/macbook.png";
import {useSelector} from "react-redux";

const LocationDesignSettings = ({emailId,saveDataShopifyFn,formik}) => {
    const {shop_data} = useSelector((store) => store.commonData.store_data);
    const [lookAdvanceCustimizaion, setLookAdvanceCustimizaion] = useState(false);
    const switcherLocationOptions = [
        {label: 'Fixed Position', value: 0},
        {label: 'Inline with the header', value: 1},
        {label: "Don't Show at all", value: 2},
    ];


    return (
        <>
            <Card >
                <Text as="h2" variant="headingSm">
                    Design Settings
                </Text>
                <br/>
                <FormLayout>
                    <FormLayout.Group condensed>
                        <MGSelect
                            labelName={`Price Format`}
                            selectValue={formik.values.priceFormat}
                            onChangeFn={(value) => {formik.setFieldValue('priceFormat', value)}}
                            optionsList={[
                                {label: 'With Currency', value: 0},
                                {label: 'Without Currency',value: 1}
                            ]}
                        />
                        <MGSelect
                            labelName={`Display Flag`}
                            selectValue={formik.values.displayFlag}
                            onChangeFn={(value) => {formik.setFieldValue('displayFlag', value)}}
                            optionsList={[
                                {label: 'Yes', value: 0},
                                {label: 'No',value: 1}
                            ]}
                        />
                        <MGSelect
                            labelName={`Flag Style`}
                            selectValue={formik.values.flagStyle}
                            onChangeFn={(value) => {formik.setFieldValue('flagStyle', value)}}
                            optionsList={[
                                {label: 'Rectangle', value: 0},
                                {label: 'Circle',value: 1}
                            ]}
                        />

                    </FormLayout.Group>
                </FormLayout>
                <div onClick={() => {setLookAdvanceCustimizaion(!lookAdvanceCustimizaion)}} style={{color:'var(--p-color-text-link)',cursor:"pointer", marginTop:"1rem"}}>
                    <Text fontWeight="regular" Tone='magic' as="h2" variant="headingMd">
                        Advance Customization <div style={{display:"inline-block", transform : lookAdvanceCustimizaion && 'rotate(90deg)'}}>></div>
                    </Text>
                </div>

                {lookAdvanceCustimizaion ?
                    <div style={{marginTop:"1rem"}}>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <MGSelect
                                    labelName={`Display Border`}
                                    selectValue={formik.values.displayBorder}
                                    onChangeFn={(value) => formik.setFieldValue('displayBorder', value) }
                                    optionsList={[
                                        {label: 'Yes', value: 0},
                                        {label: 'No',value: 1}
                                    ]}
                                />
                                <TextField
                                    label="Border Line Color"
                                    placeholder="Default"
                                    value={formik.values.borderLineColor}
                                    suffix={
                                        <>
                                            <div style={{display:"flex",gap:"0.6rem"}}>
                                                <input value={(formik.values.borderLineColor === 'Default') ? '#ffffff'  : formik.values.borderLineColor }
                                                       onChange={(event) => formik.setFieldValue('borderLineColor', event.target.value)}
                                                       style={{appearance : "none", inlineSize : "60px", blockSize : '40px', borderWidth : 0, padding : 0, background : "none"}}
                                                       type="color"
                                                />
                                                <div onClick={() => formik.setFieldValue('borderLineColor', '#cccccc')} style={{display:"flex",alignItems:"center",cursor:"pointer",color:"var(--p-color-text-link)"}}> <span>Set Default</span> </div>
                                            </div>

                                        </>
                                    }
                                />
                                <TextField
                                    label="Text Color"
                                    placeholder="Default"
                                    value={formik.values.textColor}
                                    suffix={
                                        <>
                                            <div style={{display:"flex",gap:"0.6rem"}}>
                                                <input value={(formik.values.textColor === 'Default') ? '#ffffff'  : formik.values.textColor }
                                                       onChange={(event) => formik.setFieldValue('textColor', event.target.value)}
                                                       style={{appearance : "none", inlineSize : "60px", blockSize : '40px', borderWidth : 0, padding : 0, background : "none"}}
                                                       type="color"
                                                />
                                                <div onClick={() => formik.setFieldValue('textColor', '#000000')} style={{display:"flex",alignItems:"center",cursor:"pointer",color:"var(--p-color-text-link)"}}> <span>Set Default</span> </div>
                                            </div>

                                        </>
                                    }
                                />
                            </FormLayout.Group>
                            <FormLayout.Group condensed>
                                <TextField
                                    label="Text Hover Color"
                                    placeholder="Default"
                                    value={formik.values.textHoverColor}
                                    suffix={
                                        <>
                                            <div style={{display:"flex",gap:"0.6rem"}}>
                                                <input value={(formik.values.textHoverColor === 'Default') ? '#ffffff'  : formik.values.textHoverColor }
                                                       onChange={(event) => formik.setFieldValue('textHoverColor',event.target.value)}
                                                       style={{appearance : "none", inlineSize : "60px", blockSize : '40px', borderWidth : 0, padding : 0, background : "none"}}
                                                       type="color"
                                                />
                                                <div onClick={() => formik.setFieldValue('textHoverColor', '#000000')} style={{display:"flex",alignItems:"center",cursor:"pointer",color:"var(--p-color-text-link)"}}> <span>Set Default</span> </div>
                                            </div>
                                        </>
                                    }
                                />
                                <TextField
                                    label="Background Color"
                                    placeholder="Default"
                                    value={formik.values.backgroundColor}
                                    suffix={
                                        <>
                                            <div style={{display:"flex",gap:"0.6rem"}}>
                                                <input value={(formik.values.backgroundColor === 'Default') ? '#ffffff'  : formik.values.backgroundColor }
                                                       onChange={(event) => formik.setFieldValue('backgroundColor',event.target.value)}
                                                       style={{appearance : "none", inlineSize : "60px", blockSize : '40px', borderWidth : 0, padding : 0, background : "none"}}
                                                       type="color"
                                                />
                                                <div onClick={() => formik.setFieldValue('backgroundColor','#f4f4f4')} style={{display:"flex",alignItems:"center",cursor:"pointer",color:"var(--p-color-text-link)"}}> <span>Set Default</span> </div>
                                            </div>
                                        </>
                                    }
                                />
                                <TextField
                                    label="Hover Background Color"
                                    placeholder="Default"
                                    value={formik.values.hoverBackgroundColor}
                                    suffix={
                                        <>
                                            <div style={{display:"flex",gap:"0.6rem"}}>
                                                <input value={(formik.values.hoverBackgroundColor === 'Default') ? '#ffffff'  : formik.values.hoverBackgroundColor }
                                                       onChange={(event) => formik.setFieldValue('hoverBackgroundColor',event.target.value)}
                                                       style={{appearance : "none", inlineSize : "60px", blockSize : '40px', borderWidth : 0, padding : 0, background : "none"}}
                                                       type="color"
                                                />
                                                <div onClick={() => formik.setFieldValue('hoverBackgroundColor','#f4f4f4')} style={{display:"flex",alignItems:"center",cursor:"pointer",color:"var(--p-color-text-link)"}}> <span>Set Default</span> </div>
                                            </div>
                                        </>
                                    }
                                />
                            </FormLayout.Group>
                        </FormLayout>
                    </div>
                    : null}
                <div className="store-integration-message-div" style={{justifyContent:"end"}}>
                    <Button loading={formik.values?.designSettingsLoader} onClick={() => {saveDataShopifyFn('designSettingsLoader')}} size="large" variant="primary">save</Button>
                </div>
            </Card>
            <br/>
            <Card >
                <Text as="h2" variant="headingSm">
                    Location
                </Text>
                <br/>
                <InlineGrid gap="400" columns={2}>
                    <div>
                        <MGSelect
                            labelName={`Switcher Location`}
                            selectValue={formik.values.switcherLocation}
                            onChangeFn={(value) => formik.setFieldValue('switcherLocation',value)}
                            optionsList={switcherLocationOptions}
                        />
                        {formik.values.switcherLocation?.value === 0 ?
                            <ul>
                                <li>Switcher will be fixed always at a selected position even on page scroll.</li>
                                <li>If you're not happy with how the switcher looks, just send us an email at <Link url={`mailto:${emailId}`}>{emailId}</Link>. We'll customize it for you free of charge.</li>
                            </ul>
                            : null}
                    </div>
                    <div>
                        {formik.values.switcherLocation?.value === 0 ?
                            <>
                                <div className="mg-currencyLocation--main-div"><img src={macBookImg} />
                                    <div className="mg-currency-show">
                                        <div>
                                            <input onClick={() => formik.setFieldValue('selectFixedPosition',0)} type="checkbox" name="positionTopLeftChecked" checked={formik.values.selectFixedPosition === 0} />
                                        </div>
                                        <div>
                                            <input onClick={() => formik.setFieldValue('selectFixedPosition',1)} type="checkbox" name="positionTopRightChecked" checked={formik.values.selectFixedPosition === 1} />
                                        </div>
                                        <div>
                                            <input onClick={() => formik.setFieldValue('selectFixedPosition',2)} type="checkbox" name="positionBottomLeftChecked" checked={formik.values.selectFixedPosition === 2} />
                                        </div>
                                        <div>
                                            <input onClick={() => formik.setFieldValue('selectFixedPosition',3)} type="checkbox"name="positionBottomRightChecked" checked={formik.values.selectFixedPosition === 3} />
                                        </div>
                                    </div>
                                </div>
                            </>
                            : formik.values.switcherLocation?.value === 1 ? <div style={{marginTop : "1rem"}}>
                                <ul>
                                    <li>
                                        If you want the switcher shows into the header on desktop and the menu on mobile, follow these steps:
                                        <ol>
                                            <li>
                                                Add <Link url={`mailto:${emailId}`}>{emailId}</Link> as a staff member to your store with access to Themes, Apps, and Settings <Link url={`https://${shop_data.store_name}/admin/settings/account/new`} external>Here</Link>.
                                            </li>
                                            <li>
                                                Email us at <Link url={`mailto:${emailId}`}>{emailId}</Link> with your requirements.
                                            </li>
                                        </ol>
                                    </li>
                                </ul>
                            </div> : formik.values.switcherLocation?.value === 2 ? <div style={{marginTop : "1rem"}}>
                                <ul>
                                    <li>
                                        With this option, the currency switcher won’t be shown, but your prices will still be converted based on your settings.
                                    </li>
                                </ul>
                            </div> : null
                        }

                    </div>
                </InlineGrid>
                <div className="store-integration-message-div" style={{justifyContent:"end"}}>
                    <Button loading={formik.values?.locationSettingLoader} onClick={() => {saveDataShopifyFn('locationSettingLoader')}} size="large" variant="primary">save</Button>
                </div>
            </Card>
            <br/>
        </>
    );
};

export default LocationDesignSettings;
